<footer class="footer-custom">
    <div class="footer-content">
        <div class="footer-columns">
            <div class="footer-col">
                <h3>Produtos</h3>
                <ul>
                    <li>Cardiometabólicos</li>
                    <li>Dermatológicos</li>
                    <li>Gástricos</li>
                    <li>Ginecológicos</li>
                </ul>
            </div>
            <div class="footer-col">
                <h3>&nbsp;</h3>
                <ul>
                    <li>Hematológicos</li>
                    <li>Oncológicos</li>
                    <li>Respiratórios</li>
                    <li>Sistema Nervoso</li>
                </ul>
            </div>
            <div class="footer-col">
                <h3>Serviço ao comprador</h3>
                <ul>
                    <li>Rastrear pedido</li>
                    <li>Saldo BitLibbs</li>
                    <li>Plano promocional</li>
                    <li>Minha carteira</li>
                </ul>
            </div>
            <div class="footer-col">
                <h3>Suporte</h3>
                <ul>
                    <li>Segunda a sexta-feira</li>
                    <li>Das 8h à 18h</li>
                    <li><a href="mailto:suporte&#64;libbs.com.br">suporte&#64;libbs.com.br</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-logo-box">
            <img src="/images/lojinha-logo-slogan.png" alt="Lojinha Libbs" class="footer-logo-img" style="height: 38px; width: auto" />
        </div>
    </div>
</footer>
<app-copyright-bar></app-copyright-bar>
